import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import { MediaFile } from './MediaFile'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { insertImage } from './insertImage'
import { useCompleteDesignAction } from '../utils/useCompleteDesignAction'
import { DesignActionType } from 'types'
import { IMediaFile } from './Types'
import { track } from '@tldraw/tldraw'
import { getCurrentFrame } from 'components/VisualStudioPlayground/VisualEditor/helpers'
import { useInsertMediaFile } from '../utils/useInsertMediaFile'
import { isVideo } from 'components/ImagePickerModal/utils'
import { insertVideo } from './insertVideo'
import { createBackground } from '../BackgroundsTab/createBackground'
import { useUploadsTab } from './UploadsTabContext'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export const UploadedFile = track(
  observer(({ file, size }: { file: IMediaFile; size?: { height: number; width: number } }) => {
    const { designStore, drawersStore } = useRootStore()
    const { isMobile } = useResponsiveDesign()
    const editor = useEditor()
    const { forBackground } = useUploadsTab()
    const completeActionMutation = useCompleteDesignAction()
    const insertMediaFile = useInsertMediaFile()
    const { source_url, thumbnail_url } = file
    const src = thumbnail_url || source_url
    const isVideoFile = isVideo({ type: file.mime_type })

    const handlePress = async () => {
      if (isVideoFile) {
        insertVideo(editor, file)
        drawersStore.closeDrawer()
        return
      }

      if (forBackground && file.width && file.height) {
        createBackground(editor, {
          src: file.source_url,
          w: file.width,
          h: file.height,
          mimeType: file.mime_type || 'image/png',
        })
        if (isMobile) drawersStore.resetSnap()

        return
      }

      if (file.mime_type === 'image/svg+xml') {
        insertImage(editor, file)
        completeActionMutation.mutate({ action: DesignActionType.CoreImage })
        drawersStore.closeDrawer()
        return
      }

      designStore?.setProcessingShapeId(getCurrentFrame(editor).id)
      await insertMediaFile(
        editor,
        {
          mediaFile: file,
          transformations: {},
        },
        {
          replaceReplaceable: true,
        },
      )
      completeActionMutation.mutate({ action: DesignActionType.CoreImage })
      designStore?.setProcessingShapeId(undefined)
      drawersStore.closeDrawer()
    }

    return (
      <MediaFile
        key={file.id}
        aria-label={`Add this ${isVideoFile ? 'video' : 'photo'} to the canvas`}
        src={src}
        file={file}
        onPress={handlePress}
        payload={{ special_type: 'media_file' }}
        size={size}
      />
    )
  }),
)
